import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import StoryViewer from './StoryViewer/StoryViewer';

const ShowStoryModal = ({
  isOpen,
  onClose,
  stories = [],
  initialStoryIndex = 0,
  currentUser,
  onStoryDeleted,
  onStoryViewed, // Callback to notify parent of viewed stories
  viewedStoryIds = new Set(), // Pass viewed story IDs to StoryViewer
}) => {
  const handleClose = (reason) => {
    console.log("Closing modal. Reason:", reason);
    if (onClose) onClose();
  };

  // Close on Escape key press
  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        handleClose("Escape key");
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleStoryViewed = (viewedStoryIds) => {
    if (onStoryViewed) {
      onStoryViewed(viewedStoryIds);
    }
  };

  const modalContent = (
    <div
      data-modal="story-modal"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1000,
        backgroundColor: 'rgba(0, 0, 0, 0.9)', // Dark backdrop
        backdropFilter: 'blur(10px)', // Glassmorphism backdrop
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // Animation for modal entrance
        animation: 'fadeIn 0.3s ease-out',
        cursor: 'pointer' // Indicates the backdrop is clickable
      }}
      onClick={() => handleClose("Backdrop click")} // Click outside to close
      onMouseDown={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
      onTouchEnd={(e) => e.stopPropagation()}
    >
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
        `}
      </style>

      {/* Story Viewer Container – stop propagation so clicks inside don't close the modal */}
      <div style={{
        width: '100%',
        height: '100%',
        maxWidth: '500px', // Mobile-like dimension on desktop
        maxHeight: '100%', // Full height
        position: 'relative',
        backgroundColor: '#000',
        boxShadow: '0 0 20px rgba(0,0,0,0.5)',
        overflow: 'hidden',
        cursor: 'default'
      }}
        onClick={(e) => e.stopPropagation()} // Stop propagation from viewer so backdrop click doesn't fire
      >
        <StoryViewer
          stories={stories}
          initialStoryIndex={initialStoryIndex}
          currentUser={currentUser}
          onClose={() => handleClose("StoryViewer Request")}
          onDeleteSuccess={onStoryDeleted}
          onStoryViewed={handleStoryViewed}
          viewedStoryIds={viewedStoryIds}
        />
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default ShowStoryModal;
